import * as React from 'react';
import { routeInfo } from './routeInfo';
import { Route, IndexRoute, Redirect } from 'react-router';
import PageLoader from './views/components/PageLoader/PageLoader';
import device from './services/mini/device';
import { ErrorFallback } from './views/components/ErrorFallback/ErrorFallback';
import AlanContainer from './views/containers/AlanContainer';
const LoginPage = React.lazy(() => import('./views/pages/login/LoginPage/LoginPage'));
const ProjectsPage = React.lazy(() => import('./views/pages/projects/ProjectsPage/ProjectsPage'));
const EmbedPage = React.lazy(() => import('./views/pages/embed/EmbedPage/EmbedPage'));
const ProjectPage = React.lazy(() => import('./views/pages/project/ProjectPage/ProjectPage'));
const ProjectPageMobile = React.lazy(() => import('./views/pages/project/ProjectPageMobile/ProjectPageMobile'));
const AnalyticsPage = React.lazy(() => import('./views/pages/analytics/AnalyticsPage/AnalyticsPage'));
const SettingsPage = React.lazy(() => import('./views/pages/settings/SettingsPage/SettingsPage')); // todo: rename to Profile
const CompareModePage = React.lazy(() => import('./views/pages/compare/CompareModePage/CompareModePage'));
const CorpusPage = React.lazy(() => import('./views/pages/corpuse/CorpusPage/CorpusPage'));
const OrganizationPage = React.lazy(() => import('./views/pages/organization/OrganizationPage/OrganizationPage'));
const BillingPage = React.lazy(() => import('./views/pages/billing/BillingPage'));
const PlansPage = React.lazy(() => import('./views/pages/plans/PlansPage'));
const InviteFriendsPage = React.lazy(() => import('./views/pages/inviteFriends/InviteFriendsPage'));


function getProjectPage() {
       if (device.isMobile()) {
              return ProjectPageMobile;
       }
       return ProjectPage;
}

export default (
       <Route path={routeInfo.index.path} component={AlanContainer}>
              <IndexRoute
                     component={LoginPage}
                     signIn={true}
              />
              <Route path={routeInfo.login.path}
                     component={LoginPage}
                     signIn={true}
              />
              <Route path={routeInfo.githubOauth.path}
                     component={PageLoader}
                     noAuthRequired={true}
              />
              <Route path={routeInfo.planVerification.path}
                     component={PageLoader}
                     noAuthRequired={true}
              />
              <Route path={routeInfo.orgMemberVerification.path}
                     component={PageLoader}
                     noAuthRequired={true}
              />
              <Route path={routeInfo.loginWithGithub.path}
                     component={LoginPage}
                     accountType="github"
                     noAuthRequired={true}
                     signIn={true}
              />
              <Route path={routeInfo.oauth.path}
                     component={LoginPage}
                     noAuthRequired={true}
                     accountType="google"
                     signIn={true}
              />
              <Route path={routeInfo.loginVerify.path}
                     noAuthRequired={true}
                     component={LoginPage}
                     signIn={true}
                     verify={true}
              />
              <Route path={routeInfo.loginWithEmail.path}
                     noAuthRequired={true}
                     component={LoginPage}
                     signIn={true}
                     loginWithKnownEmail={true}
              />
              <Route path={routeInfo.loginWithEmailAndHex.path}
                     noAuthRequired={true}
                     component={LoginPage}
                     signIn={true}
                     loginWithKnownEmail={true}
              />
              <Route path={routeInfo.register.path}
                     noAuthRequired={true}
                     component={LoginPage}
                     signIn={false}
              />
              <Route path={routeInfo.registerWithEmail.path}
                     noAuthRequired={true}
                     component={LoginPage}
                     signIn={false}
              />
              <Route path={routeInfo.registered.path}
                     noAuthRequired={true}
                     component={LoginPage}
                     emailSent={true}
              />
              <Route path={routeInfo.verificationEmailSent.path}
                     noAuthRequired={true}
                     component={LoginPage}
                     emailSent={true}
                     verificationEmailWasAlreadySent={true}
              />
              <Route path={routeInfo.restorePassword.path}
                     noAuthRequired={true}
                     component={LoginPage}
                     requestPasswordRecovery={true}
              />
              <Route path={routeInfo.restorePasswordWithEmail.path}
                     noAuthRequired={true}
                     component={LoginPage}
                     requestPasswordRecovery={true}
              />
              <Route path={routeInfo.recoveryWithEmailAnsHex.path}
                     noAuthRequired={true}
                     component={LoginPage}
                     passwordRecovery={true}
              />
              <Route path={routeInfo.projects.path}
                     component={ProjectsPage}
              />
              <Route path={routeInfo.project.path}
                     component={getProjectPage()}
                     isProjectRequired={true}
                     isPositiveBalanceRequired={true}
                     editMode={true}
              />
              <Route path={routeInfo.embed.path}
                     isProjectRequired={true}
                     component={EmbedPage}
                     isPositiveBalanceRequired={true}
              />
              <Route path={routeInfo.projectScripts.rootPath}
                     component={getProjectPage()}
                     isProjectRequired={true}
                     editMode={true}
                     isPositiveBalanceRequired={true}
              />
              <Route path={routeInfo.projectScripts.path}
                     component={getProjectPage()}
                     isProjectRequired={true}
                     editMode={true}
                     isPositiveBalanceRequired={true}
              />
              <Route path={routeInfo.projectTests.rootPath}
                     component={ProjectPage}
                     editMode={false}
                     isPositiveBalanceRequired={true}
              />
              <Route path={routeInfo.projectTests.path}
                     component={ProjectPage}
                     editMode={false}
                     isPositiveBalanceRequired={true}
              />
              <Route path={routeInfo.diff.path}
                     component={CompareModePage}
                     isProjectRequired={true}
                     isPositiveBalanceRequired={true}
              />
              <Route path={routeInfo.corpuses.path}
                     component={CorpusPage}
                     isProjectRequired={true}
                     isPositiveBalanceRequired={true}
              />
              <Route path={routeInfo.analytics.path}
                     component={AnalyticsPage}
                     isProjectRequired={true}
                     editMode={false}
                     isAllowedPath="analytics.enabled"
                     isPositiveBalanceRequired={true}
              />
              <Route path={routeInfo.inviteFriends.path}
                     component={InviteFriendsPage}
                     isAllowedPath="inviteFriends.enabled"
              />
              <Route path={routeInfo.profile.path}
                     component={SettingsPage}
              />
              <Route path={routeInfo.billing.path}
                     component={BillingPage}
                     isAllowedPath="billing.enabled"
              />
              <Route path={routeInfo.organization.path}
                     component={OrganizationPage}
                     isAllowedPath="organization.enabled"
              />
              <Route path={routeInfo.plans.path}
                     component={PlansPage}
                     isAllowedPath="billing.enabled"
              />
              <Route path={routeInfo.oops.path}
                     component={ErrorFallback}
              />
              <Redirect from="/*" to={routeInfo.login.path} />
       </Route>
);
